var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconMinus = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1239",
    "data-name": "Group 1239",
    transform: "translate(-1092 -318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(400.007 -494.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "pause_circle_outline-24px",
    "data-name": "pause circle outline-24px",
    d: "M696.493,819.743a.752.752,0,0,0,.75.75h4.5a.75.75,0,0,0,0-1.5h-4.5A.752.752,0,0,0,696.493,819.743Zm3-7.5a7.5,7.5,0,1,0,7.5,7.5A7.5,7.5,0,0,0,699.493,812.243Zm0,13.5a6,6,0,1,1,6-6A6,6,0,0,1,699.493,825.743Z",
    fill: "#173a6d"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMinus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_minus.107041e4.svg";
export { ForwardRef as ReactComponent };